// removed by extract-text-webpack-plugin
module.exports = {"banner":"src-components-Banner----banner-module---banner---31KmZ src-styles----utils---shadowLvl1---1bhdJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Banner/banner.module.scss
// module id = 63
// module chunks = 70144966829960 208176855801404 263791100135453